export interface ClassificationOperationPlan {
	toAdd: string[];
	toRemove: string[];
	total: number;
}

export class ClassificationEditPlan {
	private readonly originalAssignedCodes: Set<string>;
	private readonly protectedCodes: Set<string>;
	private stagedAssignedCodes: Set<string>;

	public constructor(
		assignedCodes: Iterable<string> = [],
		protectedCodes: Iterable<string> = []
	) {
		this.originalAssignedCodes = new Set(assignedCodes);
		this.protectedCodes = new Set(protectedCodes);
		this.stagedAssignedCodes = new Set(this.originalAssignedCodes);
	}

	public get isDirty(): boolean {
		return this.operationPlan.total > 0;
	}

	public get operationPlan(): ClassificationOperationPlan {
		const toAdd = [...this.stagedAssignedCodes]
			.filter(code => !this.protectedCodes.has(code))
			.filter(code => !this.originalAssignedCodes.has(code))
			.sort((left, right) => left.localeCompare(right));
		const toRemove = [...this.originalAssignedCodes]
			.filter(code => !this.protectedCodes.has(code))
			.filter(code => !this.stagedAssignedCodes.has(code))
			.sort((left, right) => left.localeCompare(right));

		return {
			toAdd,
			toRemove,
			total: toAdd.length + toRemove.length
		};
	}

	public isSelected(code: string): boolean {
		return this.stagedAssignedCodes.has(code);
	}

	public wasSelected(code: string): boolean {
		return this.originalAssignedCodes.has(code);
	}

	public toggle(code: string): boolean {
		if(!code || this.protectedCodes.has(code)) {
			return false;
		}

		if(this.stagedAssignedCodes.has(code)) {
			this.stagedAssignedCodes.delete(code);
		}
		else {
			this.stagedAssignedCodes.add(code);
		}

		return true;
	}

	public reset(): void {
		this.stagedAssignedCodes = new Set(this.originalAssignedCodes);
	}
}
